import { useAuth } from "contexts/auth";
import DashBoardAdmin from "pages/authentication/dashboard/dashboard-admin";
import { useEffect } from "react";
import { Page } from "v2/components";
import { ProductivityTabBuyer, ProductivityTabSeller } from "./ProductivityTab";
import { OperationalDashboardTab } from "./OperationalDashboardTab";
import { PainelGovernanca } from "modules/governance/pages/PainelGovernanca";

export function Dashboard() {
  const { user, isExternalAuth } = useAuth();
  const userType = user?.isAdmin ? 'ADMIN' : user?.isSeller ? 'SELLER' : 'BUYER';
  const { VITE_APP_AMBIENT } = import.meta.env;
  const isNotProd = VITE_APP_AMBIENT !== 'prod' && VITE_APP_AMBIENT !== 'production';

  useEffect(() => {
    if (user && isExternalAuth && user.emailIsConfirmed && user?.organization?.hasAgreedToTermsAndConditions && user.hasPermissionRequest) {
      window.close();
    }
  }, [user, isExternalAuth]);

  return (
    <>
      {userType === 'ADMIN' && (
        <Page title="Dashboard">
          <Page.Tab name="Admin">
            <DashBoardAdmin />
          </Page.Tab>
        </Page>
      )}
      {userType === 'BUYER' && (
        <Page title="Dashboard">
          {isNotProd && (
            <Page.Tab name="Painel Operacional">
              <OperationalDashboardTab />
            </Page.Tab>
          )}
          <Page.Tab name="Produtividade">
            <ProductivityTabBuyer />
          </Page.Tab>
          <Page.Tab name="Visão Executiva de Governança">
            <PainelGovernanca />
          </Page.Tab>
          <Page.Tab name="Ativos e funcionários" disabled />
          <Page.Tab name="Compras e movimentações" disabled />
          <Page.Tab name="Direitos por contrato" disabled />
          <Page.Tab name="Meus pagamentos" disabled />
          <Page.Tab name="Minha contabilidade de gastos" disabled />
          <Page.Tab name="Meus riscos" disabled />
        </Page>
      )}
      {userType === 'SELLER' && (
        <Page title="Dashboard">
          <Page.Tab name="Produtividade">
            <ProductivityTabSeller />
          </Page.Tab>
          <Page.Tab name="Oportunidades" disabled />
          <Page.Tab name="Riscos & Compliance" disabled />
          <Page.Tab name="Working Capital" disabled />
          <Page.Tab name="Conectividade & Segurança" disabled />
        </Page>
      )}
    </>
  );
}
